import { get, type Writable, writable } from 'svelte/store';
import type { Achievement, AchievementResponse } from '../domain/Achievement';

export const achievementsStore: Writable<Achievement[]> = writable();
export const achievementResponseStore: Writable<AchievementResponse> = writable();

export const findAchievementById = (id: string) => {
	const achievementResponse = get(achievementResponseStore);
	const achievements = [
		...(achievementResponse.actualAchievements),
		...(achievementResponse.pastAchievements),
		...(achievementResponse.comingSoonAchievements ?? [])
	];
	return achievements.find(({ achievementId }) => achievementId === id);
};

export const findAllAchievementResponse = (): AchievementResponse => {
	return get(achievementResponseStore);
};

